/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';
import { withTranslation } from 'react-i18next';  // 新增

import Nav0 from './Nav0';
import Banner1 from './Banner1';
import Content5 from './Content5';
import Feature0 from './Feature0';
import Content3 from './Content3';
import Footer1 from './Footer1';

import {
  Nav01DataSource,
  Banner10DataSource,
  Content50DataSource,
  Content51DataSource,
  Feature00DataSource,
  Content30DataSource,
  Footer10DataSource,
} from './data.source';
import './less/antMotionStyle.less';

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

const { location = {} } = typeof window !== 'undefined' ? window : {};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      show: !location.port,
    };
  }

  componentDidMount() {
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    if (location.port) {
      setTimeout(() => {
        this.setState({ show: true });
      }, 500);
    }
  }

  render() {
    const { t } = this.props;  // 获取 t 函数
    const children = [
      <Nav0
        id="Nav0_1"
        key="Nav0_1"
        dataSource={Nav01DataSource(t)}   // 调用函数传入 t
        isMobile={this.state.isMobile}
      />,
      <Banner1
        id="Banner1_0"
        key="Banner1_0"
        dataSource={Banner10DataSource(t)}
        isMobile={this.state.isMobile}
      />,
      <Content5
        id="Content5_0"
        key="Content5_0"
        dataSource={Content50DataSource(t)}
        isMobile={this.state.isMobile}
      />,
      <Content5
        id="Content5_1"
        key="Content5_1"
        dataSource={Content51DataSource(t)}
        isMobile={this.state.isMobile}
      />,
      <Feature0
        id="Feature0_0"
        key="Feature0_0"
        dataSource={Feature00DataSource(t)}
        isMobile={this.state.isMobile}
      />,
      <Content3
        id="Content3_0"
        key="Content3_0"
        dataSource={Content30DataSource(t)}
        isMobile={this.state.isMobile}
      />,
      <Footer1
        id="Footer1_0"
        key="Footer1_0"
        dataSource={Footer10DataSource(t)}
        isMobile={this.state.isMobile}
      />,
    ];
    return (
      <div
        className="templates-wrapper"
        ref={(d) => { this.dom = d; }}
      >
        {this.state.show && children}
      </div>
    );
  }
}

export default withTranslation()(Home);  // 包装组件